<template>
    <div :class="['prog_taber', bAnim ? 'opitv' : '']">
        <div v-for="(item,index) in arrChange">
            <div class="prog_top_box">
                <div class="dot-box"></div>
                <div class="prog_title">{{item.title}}</div>
                <div class="prog_look" v-if="item.detail.is_change == 1"
                    @click="getToChange(item.detail.projectdesignid)">查看变更记录</div>
            </div>
            <div class="plan-box">
                <div class="plan-top-box" v-if="item.detail != ''" @click="getToDetails(item.detail.projectdesignid)">
                    <div class="plan-type" :style="{background: item.detail.is_change == 1 ? '#EE9859':'#E38677'}">
                        {{item.detail.is_change == 1 ? '变更方案':'方案设计'}}
                    </div>
                    <div class="plan-icon" v-if="item.detail.new_approvalstatus == 1">制单</div>
                    <div class="plan-icon2" v-if="item.detail.new_approvalstatus == 2">审核中</div>
                    <div class="plan-icon" v-if="item.detail.new_approvalstatus == 3">已审批</div>
                    <div class="plan-icon" v-if="item.detail.new_approvalstatus == 4">已驳回</div>
                    <div class="plan-icon" v-if="item.detail.new_approvalstatus == 5">已否决</div>
                </div>
                <div class="plan-bottom-box" v-if="item.detail != ''" @click="getToDetails(item.detail.projectdesignid)">
                    <div class="plan-bottom-left-box">
                        <div>方案编号：{{item.detail.new_name}}</div>
                        <div>项目类型：{{item.detail.project_type}}</div>
                        <div>设计师：{{item.detail.new_designer}}</div>
                        <div>审批时间：{{item.detail.approved_time}}</div>
                    </div>
                    <div class="plan-bottom-right-box" v-if="item.detail.has_3d == 1">
                        <div class="upload">3D方案已上传</div>
                        <div class="arrow_icon"><img src="@/assets/images/archives/dossier/arrow_icon.png" /></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dossier-img" v-if="this.arrChange.length < 1">
            <img src="@/assets/images/archives/dossier/contract_not.png" />
            <div class="noMore">暂无信息</div>
        </div>
    </div>
</template>

<script>
    import oInfo from '@/js/archives/survey/index.js'
    export default {
        name: "DossierNavBar",
        props: {
            bAnim: {
                type: Boolean,
                default: false,
            },
            projectId: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                arrChange: [],
            }
        },
        created() {
            this.getToData()
            console.log(this.projectId, 'popopnProject')
        },
        methods: {
            getToData() {
                this.$store.commit("loadSwitch", true);
                oInfo.designTags({
                    project_id: this.projectId,
                }).then(res => {
					this.$store.commit("loadSwitch", false);
                    this.arrChange = res.data.data.result.list
                })
            },
            getToChange(prog) {
                this.$router.push({
                    path: `/archives/design/change?id=${this.projectId}&prog=${prog}`,
                })
            },
            getToDetails(prog) {
                this.$router.push({
                    path: `/archives/design/details?id=${this.projectId}&prog=${prog}`,
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .opitv {
        animation: opitv 0.7s forwards;
    }

    @keyframes opitv {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
            transform: translateX(-30px);
        }
    }

    .prog_taber {
        padding: 32px 0 32px 32px;

        .dossier-img {
            text-align: center;

            /* margin: 0 auto; */
            img {
                width: 400px;
                height: 422px;
            }

            .noMore {
                font-size: 28px;
                font-weight: 400;
                color: #999999;
                text-align: center;
            }
        }

        .prog_top_box {
            display: flex;

            .dot-box {
                width: 16px;
                height: 16px;
                background-color: #0D53FC;
                // border: 6px solid #0D53FC;
                border-radius: 50%;
                margin-top: 8px;
            }

            .prog_title {
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #3D3C4F;
                margin-left: 32px;
            }

            .prog_look {
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #0D53FC;
                text-decoration: underline;
                margin-left: 8px;
            }
        }

        .plan-box {
            padding: 32px 32px 80px 40px;
            border-left: 5px dashed #F5F5F5;
            margin-left: 5.5px;
            // width: ;

            .plan-top-box {
                // width: 638px;
                height: 64px;
                background: #F9F9FB;
                border-radius: 16px 16px 0px 0px;
                display: flex;
                justify-content: space-between;
                padding-right: 32px;
                border-bottom: 2px solid #EAEAEA;

                .plan-type {
                    width: 160px;
                    height: 64px;
                    // background: #EE9859;
                    border-radius: 16px 0px 0px 0px;
                    line-height: 64px;
                    text-align: center;
                    font-size: 24px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    color: #FFFFFF;
                }

                .plan-icon {
                    width: 96px;
                    height: 40px;
                    margin-top: 12px;
                    text-align: center;
                    line-height: 38px;
                    font-size: 24px;
                    color: #24AE71;
                    border-radius: 106px 106px 106px 106px;
                    border: 2px solid #24AE71;
                }
                .plan-icon2{
                    width: 96px;
                    height: 40px;
                    margin-top: 12px;
                    text-align: center;
                    line-height: 38px;
                    font-size: 24px;
                    color: #EEB038;
                    border-radius: 106px 106px 106px 106px;
                    border: 2px solid #EEB038;
                }
            }

            .plan-bottom-box {
                position: relative;
                padding: 32px 32px 16px 32px;
                display: flex;
                background: #F9F9FB;
                border-radius: 0 0 16px 16px;

                .plan-bottom-left-box {
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;

                    div {
                        margin-bottom: 16px;
                    }
                }

                .plan-bottom-right-box {
                    position: absolute;
                    right: 32px;
                    top: 50%;
                    transform: translate(0%, -50%);
                    display: flex;

                    .upload {
                        font-size: 22px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #CCCCCC;
                    }

                    .arrow_icon {
                        margin-top: 4px;
                        margin-left: 8px;

                        img {
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
            }

            // <div class="plan-bottom-box">
            //     <div class="plan-bottom-left-box">
            //         <div>方案编号：FA20220418</div>
            //         <div>项目类型：空调壁挂炉(地暖)项目</div>
            //         <div>设计师：盛丽花</div>
            //         <div>审批时间：2022.4.19</div>
            //     </div>
            //     <div class="plan-bottom-right-box">
            //         <div class="upload">3D方案已上传</div>
            //         <div class="arrow_icon"><img src="@/assets/images/archives/dossier/arrow_icon.png"/></div>
            //     </div>
            // </div>
        }
    }
</style>
